module.exports = __webpack_public_path__ + "img/7pica.82d62864.png";